var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExpanded = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2075_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 14.6668C11.6807 14.6668 14.6654 11.6822 14.6654 8.00016C14.6654 4.31816 11.6807 1.3335 7.9987 1.3335C4.3167 1.3335 1.33203 4.31816 1.33203 8.00016C1.33203 11.6822 4.3167 14.6668 7.9987 14.6668Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 7.16016L8.00177 9.50682L10.3551 7.16016",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2075_1157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpanded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expanded.5deb2e36.svg";
export { ForwardRef as ReactComponent };